module.exports = __webpack_public_path__ + "static/img/manual_ja_15.6cf176a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/ja/manual_ja_15.png
// module id = 3j5A
// module chunks = 4